import { WSService } from "../../utils/WSService";

export const serviceCustomization = new WSService("/users");
